const escape_escape_regex = /\\/g;
const escape_escape_replace = "\\\\";
const escape_quote_regex = /'/g;
const escape_quote_replace = "\\'";

export = function escape(str: string): string {
	return /\?|\*|:|#|\.|%|\+~>|(_type$)|(^item operation$)/g.test(str)
		? "'" +
				str.replace(escape_escape_regex, escape_escape_replace).replace(escape_quote_regex, escape_quote_replace) +
				"'"
		: str;
};
